<ng-container [ngSwitch]="status">
    <label class="status status-success"
           *ngSwitchCase="EventStatus.SENT">
        <i class="fa fa-circle"></i><span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.status.sent'}]"></span>
    </label>
    <label class="status status-danger-light"
           [i18n]="[{target: 'attribute:title', key: 'webhooks-events.status.next-try-date', params: {tryDate: nextTryDate | fullDate}}]"
           *ngSwitchCase="EventStatus.RETRYING">
        <i class="fa fa-circle"></i><span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.status.retrying'}]"></span>
    </label>
    <label class="status status-danger"
           *ngSwitchCase="EventStatus.FAILED">
        <i class="fa fa-circle"></i><span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.status.failed'}]"></span>
    </label>
    <label class="status status-warning"
           *ngSwitchCase="EventStatus.IN_PROGRESS">
        <i class="fa fa-circle"></i><span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.status.in-progress'}]"></span>
    </label>
    <label class="status"
           *ngSwitchCase="EventStatus.IGNORED">
        <i class="fa fa-circle"></i><span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.status.ignored'}]"></span>
    </label>
    <label class="status"
           *ngSwitchDefault>
        <i class="fa fa-question-circle"></i><span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.status.unknown'}]"></span>
    </label>
</ng-container>
